module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/doctors/noimage_s80x80-742f23edcc206015bfc251e1cc9021f3.jpg";